"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  ", ";\n  border: none;\n  border-radius: 4px;\n  padding: 16px;\n"], ["\n  ", ";\n  border: none;\n  border-radius: 4px;\n  padding: 16px;\n"]);

var _Card = require("./Card");

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ResultCard = _styledComponents2.default.div.withConfig({
  displayName: "ResultCard",
  componentId: "sc-172f24o-0"
})(_templateObject, _Card.CardStyle);

exports.default = ResultCard;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-card/dist/components/ResultCard.js
// module id = 396
// module chunks = 168707334958949